import { Controller } from "@hotwired/stimulus"

import $ from "jquery"

require("../../assets/javascripts/octo_alert")

$.fn.highlight = function (color) {
  $(this).each(function () {
    var el = $(this);
    $("<div></div>")
      .width(el.outerWidth())
      .height(el.outerHeight())
      .css({
        "position": "absolute",
        "left": el.offset().left,
        "top": el.offset().top,
        "background-color": color || "#ffff99",
        "opacity": ".7",
        "z-index": "9999999"
      }).appendTo('body').fadeOut(1000).queue(function () { $(this).remove(); });
  });
}

export default class extends Controller {
  static targets = [
    "select",
    "destroyButton"
  ]

  connect() {
    if (!this.hasSelectTarget) return;

    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const booking_container_id = $(this.selectTarget).attr("id");
    const bookingId = $("#bookingId").text().replace(/\s/g,'');
    const selectTarget = this.selectTarget
    let container_id = $("#" + booking_container_id).val();

    $(this.selectTarget).on("select2:select", function (e) {
      let bc_id = booking_container_id.replace('booking_container_','');
      container_id = $("#" + booking_container_id).val();

      if (container_id) {
        $.ajax({
          url: "/bookings/" + bookingId + "/container_marriages.json",
          type: "POST",
          data: {
            container_id: container_id,
            booking_container_id: bc_id
          },
          beforeSend: function(xhr) {
            xhr.setRequestHeader('X-CSRF-Token', csrfToken);
          },
          success: function(data){
            container_id = $("#" + booking_container_id).val();
            $("#" + booking_container_id).parent().highlight();
          },
          error: function(data) {
            octoAlert({
              id:"marry-booking-container-failed",
              type:"warning",
              text: data,
              position:'.panel-body'
            });

            if (data.responseJSON.errors) {
              alert(data.responseJSON.errors);
            }
          }
        });
      }
    })

    if (this.hasDestroyButtonTarget) {
      $(this.destroyButtonTarget).on("click", function (e) {
        e.preventDefault();
        if (container_id && container_id != '' && booking_container_id) {
          $.ajax({
            url: "/bookings/" + bookingId + "/container_marriages/" + booking_container_id + ".json",
            type: "DELETE",
            data: {
              container_id: container_id
            },
            beforeSend: function(xhr) {
              xhr.setRequestHeader('X-CSRF-Token', csrfToken);
            },
            success: function(data){
              $(selectTarget).empty().trigger("select2:clear")
              $(selectTarget).parent().highlight()
            }
          });
        }
      })
    }
  }
};
